import { SVGProps } from 'react';

const Snowflake = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10 20-1.25-2.5L6 18m4-14L8.75 6.5 6 6m8 14 1.25-2.5L18 18M14 4l1.25 2.5L18 6m-1 15-3-6m0 0h-4m4 0 1.5-3M10 15l-3 6m3-6-1.5-3M17 3l-3 6m0 0 1.5 3M14 9h-4m5.5 3H22M2 12h6.5m0 0L10 9m0 0L7 3m13 7-1.5 2 1.5 2M4 10l1.5 2L4 14"
    />
  </svg>
);
export default Snowflake;
